export { Modal } from "./modal.component";
